/**
 * Sistema de tracking para cotizaciones anónimas - VERSIÓN MEJORADA
 * Compatible con la implementación del backend
 */

/**
 * Genera datos de tracking completos siguiendo la especificación del backend
 */
export const generateTrackingData = () => {
  // Generar Visitor ID persistente
  let visitorId = localStorage.getItem("tattersall-visitor-id");
  if (!visitorId) {
    const timestamp = Date.now();
    const randomSuffix = Math.random().toString(36).substr(2, 9);
    visitorId = `visitor_${timestamp}_${randomSuffix}`;
    localStorage.setItem("tattersall-visitor-id", visitorId);
  }

  // Generar Session ID para esta sesión
  let sessionId = sessionStorage.getItem("tattersall-session-id");
  if (!sessionId) {
    const timestamp = Date.now();
    const randomSuffix = Math.random().toString(36).substr(2, 9);
    sessionId = `session_${timestamp}_${randomSuffix}`;
    sessionStorage.setItem("tattersall-session-id", sessionId);
  }

  // Generar Browser Fingerprint más robusto
  const browserFingerprint = generateBrowserFingerprint();

  return {
    visitorId,
    sessionId,
    browserFingerprint,
    referrer: document.referrer || "",
    currentUrl: window.location.href,
    timestamp: new Date().toISOString(),
    userAgent: navigator.userAgent,
    screenResolution: `${screen.width}x${screen.height}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    language: navigator.language,
    platform: navigator.platform,
  };
};

/**
 * Genera un fingerprint más detallado del navegador
 */
const generateBrowserFingerprint = () => {
  try {
    const components = [
      navigator.userAgent,
      navigator.language,
      navigator.platform,
      screen.width + "x" + screen.height + "x" + screen.colorDepth,
      Intl.DateTimeFormat().resolvedOptions().timeZone,
      navigator.cookieEnabled,
      navigator.doNotTrack || "unknown",
      "ontouchstart" in window,
    ];

    // Crear hash simple del fingerprint
    const fingerprintString = components.join("|");
    return btoa(fingerprintString).replace(/[+/=]/g, "").substring(0, 32);
  } catch (error) {
    // Fallback si hay algún error
    return btoa(`${navigator.userAgent}_${Date.now()}`).substring(0, 32);
  }
};

/**
 * Guarda datos de cotización anónima para asociación futura
 */
export const saveAnonymousQuoteData = (quoteId, clientData, trackingData) => {
  try {
    const anonymousQuoteData = {
      quoteId,
      clientData,
      trackingData,
      timestamp: new Date().toISOString(),
    };

    // Obtener cotizaciones anónimas existentes
    const existing = JSON.parse(
      localStorage.getItem("tattersall-anonymous-quotes") || "[]"
    );

    // Agregar nueva cotización
    existing.push(anonymousQuoteData);

    // Guardar (mantener solo las últimas 50 para evitar exceso de datos)
    const limited = existing.slice(-50);
    localStorage.setItem(
      "tattersall-anonymous-quotes",
      JSON.stringify(limited)
    );

    console.log("💾 Anonymous quote data saved:", quoteId);
  } catch (error) {
    console.warn("Error saving anonymous quote data:", error);
  }
};

/**
 * Obtiene cotizaciones anónimas guardadas
 */
export const getAnonymousQuotes = () => {
  try {
    return JSON.parse(
      localStorage.getItem("tattersall-anonymous-quotes") || "[]"
    );
  } catch (error) {
    console.warn("Error retrieving anonymous quotes:", error);
    return [];
  }
};

/**
 * Limpia datos de cotizaciones anónimas (usado después de asociación exitosa)
 */
export const clearAnonymousQuotes = () => {
  localStorage.removeItem("tattersall-anonymous-quotes");
  console.log("🧹 Anonymous quotes data cleared");
};

/**
 * Verifica si hay potencial para asociación basado en email/RUT
 */
export const checkAssociationPotential = (userEmail, userRut) => {
  const anonymousQuotes = getAnonymousQuotes();

  const matches = anonymousQuotes.filter((quote) => {
    return (
      quote.clientData.email === userEmail ||
      quote.clientData.rut === userRut ||
      quote.trackingData.visitorId ===
        localStorage.getItem("tattersall-visitor-id")
    );
  });

  return {
    hasMatches: matches.length > 0,
    matchCount: matches.length,
    matches,
  };
};
